export default __webpack_public_path__ + "static/media/01_DAIF_Data_04_01_end.5138ef4c.jpg";